import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export type FeaturedPost = {
  id: string;
  slug: string;
  title: string;
  description: string;
  image: string;
  author: string;
  authorAvatar: string;
  date: string;
};

type FeaturedBlogPostProps = {
  post: FeaturedPost;
};

const FeaturedBlogPost: React.FC<FeaturedBlogPostProps> = ({ post }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.6 }}
  >
    <Link to={`/blog/${post.slug}`} className="block">
      <section className="mt-6 lg:mt-8 mb-12 lg:mb-14 grid grid-cols-1 lg:grid-cols-[360px_1fr] gap-5 lg:gap-8 items-center">
        <img
          src={post.image}
          alt={post.title}
          className="w-full object-cover mx-auto lg:mx-0 rounded-[12px] h-[200px] max-w-[360px]"
        />
        <div className="flex flex-col lg:min-h-[200px] py-1">
          <span
            className="inline-flex self-start items-center px-3 py-1 rounded-full border border-gray-100 bg-white text-gray-500 font-description text-[10px] font-normal tracking-wider"
          >
            Article of the day
          </span>
          <h3
            className="mt-3 text-[20px] sm:text-[22px] lg:text-[28px] font-title font-medium text-[#212121] leading-[1.15]"
          >
            {post.title}
          </h3>
          <p className="mt-2 font-description text-[12px] md:text-[13px] font-light leading-[1.55] text-[#919191] max-w-[560px]">
            {post.description}
          </p>
          <div className="mt-auto pt-4 flex items-center gap-2.5 font-description text-[12px] text-[#919191] flex-wrap lg:flex-nowrap">
            <div className="w-7 h-7 rounded-full flex items-center justify-center overflow-hidden border border-gray-100 bg-blue-50">
              <img src={post.authorAvatar} alt="" className="w-full h-full object-cover" />
            </div>
            <span className="text-[#212121] font-medium font-title text-[12px]">{post.author}</span>
            <span className="w-1 h-1 rounded-full bg-gray-300 mx-1" />
            <span>{post.date}</span>
          </div>
        </div>
      </section>
    </Link>
  </motion.div>
);

export default FeaturedBlogPost;
